import React from "react";
import Layout from "../Shared/Layout";
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import AccordionList from "../Shared/AccordionList";
import {Trans} from "../utils/i18n";
import SelfHelpIcon from "../Shared/Icons/SelfHelpIcon2";
import TrackIcon from "../Shared/Icons/TrackIcon2";
import PartsShopIcon from "../Shared/Icons/PartsShopIcon";

const SpaceLeft = styled.div`
    margin-left: 45rem;
    @media (min-width: 100px) and (max-width: 1024px) {
        margin-left: 0rem;
        background: #fff;
        padding: 0px;
        width: 90%;
        height: auto;
        margin: auto;
        box-shadow: 2px 2px 8px 1px #ddd;
        position: relative;
        top: 94px;
    }
`;

export default function HomeDemoSelfHelp({languages, currentLanguage, faqs, client}) {
    return (
        <div className={"-mt-12 bgcolor"}>
            <div
                className={`w-full bg-pattern bg-center bg-no-repeat bg-cover p-2  py-16 min-h-[350px]`}
                style={{backgroundImage: `url(${client.home_banner})`}}
            >
                {/* <div className={`lg:mx-auto max-w-[2200px] relative`}>
                    <Container maxWidth="lg">
                        <SpaceLeft
                            className={`relative w-[calc(100%-45rem)] text-white flex flex-col items-center`}
                        >
                            <h1
                                className={
                                    "text-center text-black lg:text-header-icons text-3xl font-bold mt-6 m-0"
                                }
                            >
                                {client?.name}
                                &nbsp;
                                <Trans i18nKey={"welcome.whitelabel.title"}>
                                    Lifecycle Services
                                </Trans>
                            </h1>
                            <p
                                className={
                                    "text-center text-header-icons text-xl font-medium mt-4 mb-0"
                                }
                            >
                                <Trans i18nKey={"welcome.whitelabel.title.description"}>
                                    Authorized Repair Service
                                </Trans>
                            </p>
                            <p
                                className={
                                    "text-center  mt-3  mb-9 lg:mb-0 lg:mt-12"
                                }
                            >
                                <InertiaLink
                                    className={
                                        "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                    }
                                    href={route("order")}
                                >
                                    <Trans
                                        i18nKey={"welcome.serviceSolutions.selfService"}
                                    >
                                        Request Repair
                                    </Trans>
                                </InertiaLink>
                            </p>
                            <p
                                className={
                                    "text-center  mt-3  mb-9 lg:mb-0 lg:mt-6"
                                }
                            >
                                <InertiaLink
                                    className={
                                        "block font-bold text-secondary"
                                    }
                                    href={route("track.index")}
                                >
                                    <Trans
                                        i18nKey={"welcome.track_your_device"}
                                    >
                                        Check Status
                                    </Trans>
                                </InertiaLink>
                            </p>
                        </SpaceLeft>
                    </Container>
                </div> */}
            </div>
            <Container maxWidth="lg">
                <div className={"max-w-xl mx-auto"}>
                    <h2 className={"text-center text-5xl font-bold mt-16 mb-0"}>
                        <Trans i18nKey={"welcome.portalSolutions"}>
                            Portal Solutions
                        </Trans>
                    </h2>
                </div>
                <div className={"relative"}>
                    <div
                        className={
                            "mx-auto mt-20 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl"
                        }
                    >
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center box"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px]"
                                }
                            >
                                <SelfHelpIcon className={"w-40 h-40 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('selfrepair.guides.index')}
                                        className={
                                            "no-underline block font-bold text-lg bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.selfHelp"
                                            }
                                        >
                                            Self-Help
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-bold text-lg flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.selfHelp.description"
                                            }
                                        >
                                            Self-Help for any support demand, queries and issues
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <PartsShopIcon className={"w-40 h-40 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('partsshop.index')}
                                        className={
                                            "no-underline block font-bold text-lg bg-secondary rounded-md text-white px-9 py-3 hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.buyParts"
                                            }
                                        >
                                            Buy Parts
                                        </Trans>
                                    </InertiaLink>
                                    <div
                                        className={
                                            "font-bold text-lg flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.buyParts.description"
                                            }
                                        >
                                            Buy Genuine Parts
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <TrackIcon className={"w-40 h-40 text-primary"}/>
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('track.index')}
                                        className={
                                            "no-underline block font-bold text-lg bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.trackTrace"
                                            }
                                        >
                                            Track & Trace
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-bold text-lg flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.trackTrace.description"
                                            }
                                        >
                                            Real-time online status information and event changes
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {faqs.length > 0 && (
                    <div className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <>
                            <h2
                                className={
                                    "text-center text-2xl font-bold mb-0 mt-8"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.title"}>
                                    FAQs & Troubleshooting Guides
                                </Trans>
                            </h2>
                            <p
                                className={
                                    "text-center text-md font-medium mt-4"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.subtitle"}>
                                    All you need to know about our service offer
                                </Trans>
                            </p>
                            <div className="w-11/12">
                                <AccordionList items={faqs}/>
                            </div>
                        </>
                        <p className={"text-center mt-3 mb-8 pt-8"}>
                            <InertiaLink
                                className={" block font-bold text-secondary"}
                                href={route("faq")}
                            >
                                <Trans i18nKey={"welcome.checkAllResources"}>Check all the resources</Trans>
                            </InertiaLink>
                        </p>
                    </div>
                )}
            </Container>
        </div>
    );
}

HomeDemoSelfHelp.layout = (page) => <Layout children={page}/>;
